import { render, staticRenderFns } from "./PurchaseOrderMail.vue?vue&type=template&id=359f5100"
import script from "./PurchaseOrderMail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports